import React, {useState, useEffect} from 'react'
import firebase from 'firebase/app'
import {AuthContext} from '../context.js'

const AuthProvider = ({children}) => {
  const [authState, setAuthState] = useState({
    hasAuthState: false,
    isAuthenticated: false,
    user: null,
  })

  useEffect(
    () =>
      firebase.auth().onAuthStateChanged((user) =>
        setAuthState({
          hasAuthState: true,
          isAuthenticated: user !== null,
          user,
        }),
      ),
    [],
  )

  return (
    <AuthContext.Provider value={authState}>{children}</AuthContext.Provider>
  )
}

export default AuthProvider
